<template>
  <div class="page-id-auth">
    <div class="page-body">
      <info v-if="step === 0" :user-info="userInfo" :id-types="idTypes" @next="onNext" />
      <apply v-else :user-info="userInfo" :id-types="idTypes" @prev="onPrev" />
    </div>
  </div>
</template>

<script>
import Info from './components/info.vue'
import Apply from './components/apply.vue'
import { fetchIdentityList } from '@/api/member'
import './index'

export default {
  data () {
    return {
      step: 0,
      userInfo: {},
      idTypes: []
    }
  },
  async created () {
    const userInfo = this.$ls.get('USER_CENTER_INFO')

    if (userInfo) {
      this.userInfo = userInfo
    }
    // 获取身份类型列表数据
    try {
      const { list } = (await fetchIdentityList()) || {}
      if (list && list.length) {
        this.idTypes = list.map(item => {
          const { type, description, tagCode } = item
          return {
            value: type,
            label: description,
            tags: [tagCode]
          }
        })
      }
    } catch (err) {
      console.error(err)
    }
  },
  methods: {
    onNext () {
      this.step = this.step + 1
    },
    onPrev () {
      this.step = this.step - 1
    }
  },
  components: {
    Info,
    Apply
  }
}
</script>
